<template>
  <v-dialog :value="value" persistent max-width="600px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>
        <span class="headline">e-mail preferences</span>
      </v-card-title>

      <v-card-text>
        <p>Adding your email will allow to control your stations even without Telegram Access:</p>
        <v-form v-model="valid" ref="form">
          <v-text-field
            v-model="email"
            label="E-mail"
            :rules="emailRules"
            required
            :color="emailValidated ? 'green' : null"
            :append-icon="emailValidated && email == preEmail ? 'mdi-check-circle' : null"
            type="email"
          ></v-text-field>

          <div v-if="emailValidated && email == preEmail" class="green--text mt-4">
            Validated email
          </div>

          <div v-if="!preaceptedTerms" class="mt-4">
            <input type="checkbox" id="acceptTerms" v-model="acceptedTerms">
            <label for="acceptTerms"> I accept the <a href="/terms" target="_blank">terms and conditions</a>.</label>
          </div>

          <div v-if="!acceptedTerms" class="red--text mt-2">
            You must accept the terms and conditions.
          </div>

          <div class="mt-4">
            <p>Subscribe to the tinyGS newsletter:</p>
            <v-radio-group v-model="newsletterFrequency" row>
              <v-radio label="Daily" value="daily"></v-radio>
              <v-radio label="Weekly" value="weekly"></v-radio>
              <v-radio label="None" value="none"></v-radio>
            </v-radio-group>
          </div>
        </v-form>
      </v-card-text>
      <div v-if="timerActive" class="mt-2 blue--text text--darken-2" style="text-align:center;">
        Please wait {{ timerCountdown }} second<span v-if="timerCountdown !== 1">s</span> before saving again.
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onClose">
          Cancel
        </v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="onSubmit"
          :disabled="!valid || !acceptedTerms || timerActive"
        >
          <template v-if="timerActive">
            Save (wait {{ timerCountdown }}s)
          </template>
          <template v-else>
            Save
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { useGlobalTimer } from '@/composables/useGlobalTimer';

const props = defineProps({
  value: {
    type: Boolean,
    required: true
  },
  initialEmail: {
    type: String,
    default: ''
  },
  initialEmailValidated: {
    type: Boolean,
    default: false
  },
  initialPreEmail: {
    type: String,
    default: ''
  },
  initialAcceptedTerms: {
    type: Boolean,
    default: false
  },
  initialPreaceptedTerms: {
    type: Boolean,
    default: false
  },
  initialNewsletterFrequency: {
    type: String,
    default: 'none'
  }
});

const emit = defineEmits(['input', 'submit']);

const email = ref(props.initialEmail);
const emailValidated = ref(props.initialEmailValidated);
const preEmail = ref(props.initialPreEmail);
const valid = ref(true);
const acceptedTerms = ref(props.initialAcceptedTerms);
const preaceptedTerms = ref(props.initialPreaceptedTerms);
const newsletterFrequency = ref(props.initialNewsletterFrequency);

const emailRules = [
  v => !!v || 'E-mail is required',
  v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
];

const form = ref(null);

const { timerActive, timerCountdown, startTimer } = useGlobalTimer();

function onSubmit() {
  if (form.value && form.value.validate()) {
    const formData = {
      email: email.value.replace(/<[^>]+>/g, ''),
      acceptedTerms: acceptedTerms.value,
      newsletterFrequency: newsletterFrequency.value
    };
    emit('submit', formData);
    startTimer(60); // 60 segundos para este diálogo
  }
}

function onClose() {
  emit('input', false);
}
</script>